// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"ToggleButton_toggleContainer__35SeL","active":"ToggleButton_active__1bNW6"};